import { jsPDF } from 'jspdf'
import { APP_NAME, OPERATOR_NAME } from './constants'
import type { Submission } from '../types'
import { formatDate } from './utils'

export function downloadFeedbackPdf(submission: Submission, body: string): void {
  const document = new jsPDF({ unit: 'mm', format: 'a4' })
  const pageWidth = document.internal.pageSize.getWidth()
  const pageHeight = document.internal.pageSize.getHeight()
  const margin = 18
  const maxWidth = pageWidth - margin * 2
  let y = 20

  const addPageIfNeeded = (height: number) => {
    if (y + height > pageHeight - margin) {
      document.addPage()
      y = 20
    }
  }

  document.setFont('helvetica', 'bold')
  document.setFontSize(18)
  document.text(APP_NAME, margin, y)
  y += 9

  document.setFont('helvetica', 'normal')
  document.setFontSize(10)
  document.text(`Submission: ${submission.public_code}`, margin, y)
  y += 5
  document.text(`Feedback by: ${OPERATOR_NAME}`, margin, y)
  y += 5
  document.text(`Published: ${formatDate(submission.completed_at)}`, margin, y)
  y += 10

  document.setFontSize(11)
  const paragraphs = body.split(/\n\s*\n/)
  for (const paragraph of paragraphs) {
    const lines = document.splitTextToSize(paragraph.trim() || ' ', maxWidth) as string[]
    const blockHeight = lines.length * 5.5 + 4
    addPageIfNeeded(blockHeight)
    document.text(lines, margin, y)
    y += blockHeight
  }

  addPageIfNeeded(14)
  y += 4
  document.setFontSize(8.5)
  document.setTextColor(90)
  const disclaimer =
    'This is a private, informal first look based on a limited reading time. It is not peer review, scientific certification, or an editorial decision.'
  const disclaimerLines = document.splitTextToSize(disclaimer, maxWidth) as string[]
  document.text(disclaimerLines, margin, y)

  document.save(`${submission.public_code}-rapid-first-look.pdf`)
}
